
export default {
  props: {
    text: {
      type: String,
      default: '',
      required: true,
    },
    target: {
      type: String,
      default: '_self',
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    link: {
      type: String,
      default: '#',
      required: true,
    },
    color: {
      type: String,
      default: '#327DB9',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
